export default __webpack_public_path__ + "static/media/cp_wb_webex.dd60f2b7.svg";